import { render, staticRenderFns } from "./DefineGebindeComponent.vue?vue&type=template&id=5f548627"
import script from "./DefineGebindeComponent.vue?vue&type=script&lang=ts"
export * from "./DefineGebindeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports